var exports = {
  "su": "xaee3c4fa--a0da90--icon-wrapper",
  "__": "xaee3c4fa--a0da90--icon-bg",
};

module.exports = exports;
